
import { workspaceToFileTree } from '@/codeGeneration/codeGen';
import { toSnakeCase } from '@/modules/globalModule/components/helperMethods';
import { useGlobalStore } from '@/modules/globalModule/store';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import { defineComponent, PropType } from 'vue';
import { useControlCenterStore } from '../store';
import { BuildWorkspaceOnRobotStrategy } from './robotConnection/buildWorkspaceOnRobotStrategy';
import { IdleConnectionStrategy } from './robotConnection/robotConnection';

export default defineComponent({
  name: 'BuildPackagesPopup',
  props: {
    isOpen: Boolean,
    exit: {
      type: Function as PropType<() => void>,
      required: false,
      default: () => {}
    }
  },
  data(): {
    targetDir: string;
    building: boolean;
    buildingValue: number;
    buildingText: string;
    errorText: string;
  } {
    return {
      targetDir: '',
      building: false,
      buildingValue: 0,
      buildingText: '',
      errorText: ''
    };
  },
  mounted() {
    const store = useControlCenterStore();
    if (store.currConnection) {
      this.targetDir = store.currConnection.connectionDetails.buildDir;
    }
  },
  methods: {
    buildPackages() {
      const store = useControlCenterStore();
      const globalStore = useGlobalStore();
      if (!store.workspaceId || !store.currConnection) return;
      const fileTree = workspaceToFileTree(store.workspaceId);
      if (!fileTree) return;
      const buildStrategy = new BuildWorkspaceOnRobotStrategy(
        store.currConnection.connectionDetails.getSourceCommand(),
        this.targetDir,
        fileTree,
        globalStore.packages
          .filter((pkg: PackageT) => !pkg.robotPackage)
          .map((pkg) => toSnakeCase(pkg.name))
      );
      store.currConnection.connectionDetails.buildDir = this.targetDir;
      store.saveCurrentDetails();
      buildStrategy.loadProgressFunc = this.setLoadProgress;
      buildStrategy.setErrorText = this.setError;
      store.currConnection.setStrategy(buildStrategy);
      this.errorText = '';
      this.building = true;
    },
    setLoadProgress(text: string, value: number, close: boolean = false) {
      const store = useControlCenterStore();
      this.buildingText = text;
      this.buildingValue = value;
      if (close) {
        this.exit();
        this.building = false;
        if (store.currConnection) {
          store.currConnection.setStrategy(new IdleConnectionStrategy());
        }
      }
    },
    setError(text: string) {
      this.errorText = text;
    }
  }
});
